import { handleGenerateBrandUrl } from "@faire/retailer-visitor-shared/components/SearchProducts/utils";
import { useGenerateProductLinkPropsFn } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductLink/SearchProductLink";
import { useOnProductClickForSearchPage } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/productTileActions/useOnProductClickForSearchPage";
import { ILeanProductTile } from "@faire/retailer-visitor-shared/features/MarketplaceItems/MarketplaceProduct/LeanProtos/ILeanProductTile";
import { useSearchPageProductSearchString } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageProductSearchString";
import { trackSeoSearchProductListBrandLinkRefsClick } from "@faire/web-api--source/events/seo/click/searchProductListBrandLinkRefs";
import { trackEvent } from "@faire/web/common/trackEvent";
import kebabCase from "lodash/kebabCase";

export const useSearchTileInteractions = (
  productTile: ILeanProductTile | undefined,
  brandToken: string | undefined
) => {
  const { onProductClick } = useOnProductClickForSearchPage({
    token: productTile?.product?.token ?? "",
    brandToken: brandToken,
    isPromoted: productTile?.product?.is_promoted ?? false,
    impressionId: productTile?.product?.impression_id ?? "",
    promotedBy: productTile?.product?.promoted_by ?? [],
    bestImage: productTile?.best_image ?? undefined,
    images: productTile?.images ?? [],
  });

  const productLinkPropsSearch = useGenerateProductLinkPropsFn({
    token: productTile?.product?.token ?? "",
    brandToken: brandToken,
    impressionId: productTile?.product?.impression_id ?? "",
    selectedProductOptionToken:
      productTile?.selected_product_option_token ?? "",
  });
  const productSearchString = useSearchPageProductSearchString();
  const onBrandClick = () => {
    trackEvent(
      `/search-click/${kebabCase(
        productSearchString
      )}/product/${productTile?.product?.token}/brand/${brandToken}`
    );
    trackSeoSearchProductListBrandLinkRefsClick(
      brandToken ?? "",
      productSearchString
    );
  };
  const generateBrandUrl = handleGenerateBrandUrl(productSearchString, {
    productToken: productTile?.product?.token ?? "",
    brandToken: brandToken ?? "",
    impressionId: productTile?.product?.impression_id ?? "",
  });
  return {
    tileActions: {
      onProductClick: onProductClick,
      onBrandClick: onBrandClick,
    },
    props: {
      productLinkProps: productLinkPropsSearch,
      brandLinkProps: {
        brandUrl: generateBrandUrl(),
        brandToken: brandToken ?? "",
      },
    },
  };
};
